import { Button } from "@material-ui/core";
import { Launch } from "@material-ui/icons";
import { memo } from "react";
import { utils, writeFile } from "xlsx";
import {
  contractColumns,
  receivablesColumns,
  taxNotesColumns,
} from "../constants";

const ExportButton = ({ data, isGrouped, filename }) => {
  const isDisabled = !data.length;

  const exportToXLSX = () => {
    const rows = [];
    const headersIds = {};

    const invoiceColumns = [
      ...contractColumns,
      ...receivablesColumns,
      ...taxNotesColumns,
    ];

    const contractColumnsHeader = contractColumns.map((_, index) =>
      index === 0 ? "Contratos" : " "
    );
    const receivablesColumnsHeader = receivablesColumns.map((_, index) =>
      index === 0 ? "Contas a Receber" : " "
    );
    const taxNotesColumnsHeader = taxNotesColumns.map((_, index) =>
      index === 0 ? "NFSe" : " "
    );

    const groupHeaders = [
      ...contractColumnsHeader,
      ...receivablesColumnsHeader,
      ...taxNotesColumnsHeader,
    ];

    const header = invoiceColumns.map((colum) => {
      headersIds[colum.id] = colum.id;
      return colum.label;
    });

    rows.push(groupHeaders, header);

    data.forEach((cell) => {
      if (isGrouped) rows.push([cell.group?.description]);

      const dataRows = cell.elements.map((element) => [
        ...invoiceColumns.map((column) =>
          column?.format
            ? column.format(element[column.id])
            : element[column.id]
        ),
      ]);
      rows.push(...dataRows);
      const totals = invoiceColumns.map((column, columnIndex) =>
        columnIndex === 0 ? "Total:" : cell.total[column.id]
      );

      rows.push(totals);
    });

    const sheet = utils.aoa_to_sheet(rows);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, sheet, "Sheet1");
    writeFile(workbook, `${filename}.xlsx`);
  };

  return (
    <Button
      size="small"
      variant="contained"
      endIcon={<Launch />}
      style={
        isDisabled
          ? null
          : {
              backgroundColor: "#1d6f42",
              color: "#f4f4f4",
            }
      }
      onClick={exportToXLSX}
      disabled={isDisabled}
    >
      XLSX
    </Button>
  );
};

export default memo(ExportButton);
